// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "amenities__item-Eama7";
export { _1 as "__esModule", _2 as "amenities__item" }
export default { "__esModule": _1, "amenities__item": _2 }
